import React from 'react'

const UsageReportSubcategory: React.FC = () => (
  <svg width="70" height="71" viewBox="0 0 70 71" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.0769043" width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4461_1556)" />
    <g clipPath="url(#clip0_4461_1556)">
      <path
        d="M35.4003 32.6475C35.5386 32.9576 35.7004 33.2567 35.8843 33.5421L50.367 30.6608C49.7766 28.5864 48.7717 26.6533 47.413 24.9784C46.0543 23.3035 44.37 21.9215 42.462 20.9161C40.5539 19.9107 38.4618 19.3026 36.3121 19.1288C34.1624 18.955 31.9997 19.219 29.955 19.9048L35.4003 32.6475Z"
        fill="white"
      />
      <path
        d="M35.8413 37.3996C34.5784 36.4333 33.583 35.1607 32.9493 33.7023L27.5026 20.9516C25.4367 22.0429 23.6351 23.5738 22.2246 25.4365C20.8141 27.2991 19.8289 29.4483 19.3385 31.7327C18.8482 34.0171 18.8644 36.3813 19.3862 38.6587C19.9079 40.9362 20.9225 43.0716 22.3585 44.9147C23.7945 46.7577 25.617 48.2637 27.6977 49.3265C29.7785 50.3893 32.0669 50.9832 34.4018 51.0663C36.7368 51.1494 39.0616 50.7197 41.2126 49.8075C43.3637 48.8952 45.2886 47.5226 46.852 45.7863L35.8413 37.3996Z"
        fill="white"
      />
      <path
        d="M38.1536 35.8088L48.4749 43.6755C50.1243 41.111 51.001 38.126 51.0002 35.0768C50.998 34.4749 50.9619 33.8735 50.8922 33.2755L38.1536 35.8088Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4461_1556"
        x1="35"
        y1="11.0769"
        x2="34.5455"
        y2="70.0769"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6E2EBD" />
        <stop offset="1" stopColor="#4A148C" />
      </linearGradient>
      <clipPath id="clip0_4461_1556">
        <rect width="32" height="32" fill="white" transform="translate(19 19.0769)" />
      </clipPath>
    </defs>
  </svg>
)

export default UsageReportSubcategory
